import React from 'react';
import '../../ElectricFuelPages/ElectricFuel.scss';

const OfficeTableView = ({ office }: { office: any }) => {
  const statusBadge = () => {
    if (office.status === 5)
      return <span className="tag is-success is-light">Active</span>;
    return <span className="tag is-danger is-light">Inactive</span>;
  };

  const fields = [
    { label: 'Office City', value: office.office_city, icon: 'fa fa-building' },
    { label: 'State', value: office.state_name, icon: 'fa fa-map-marker' },
    { label: 'Pin Code', value: office.pin_code, icon: 'fa fa-map-pin' },
    { label: 'GST No.', value: office.gst_no, icon: 'fa fa-file-text' },
    { label: 'PAN No.', value: office.pan_no, icon: 'fa fa-id-card' },
    { label: 'CGST (%)', value: office.cgst, icon: 'fa fa-percent' },
    { label: 'SGST (%)', value: office.sgst, icon: 'fa fa-percent' },
    { label: 'IGST (%)', value: office.igst, icon: 'fa fa-percent' },
    { label: 'Address', value: office.address_one, icon: 'fa fa-home' },
  ];

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-building"></i>
      </div>
      <div className="columns is-multiline">
        {fields.map((field, idx) => (
          <div className="column is-6" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value ?? '—'}</p>
            </div>
          </div>
        ))}
        <div className="column is-6">
          <div className="detail-view-field">
            <p className="detail-view-label">
              <i className="fa fa-toggle-on mr-1"></i> Status
            </p>
            <p className="detail-view-value">{statusBadge()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeTableView;
